import React, { PureComponent, ReactNode } from 'react';
import styled from 'styled-components';

import { CosmosComponent } from 'src/types';
import { append } from '../../utils';

import {
  DropdownDeprecated,
  DropdownDeprecatedProps,
} from '../deprecated/DropdownDeprecated';
import { HorizontalSelect, HorizontalSelectProps } from '../HorizontalSelect';
import { Labeled, LabeledProps } from '../Labeled';

type LabeledDropdown = Omit<LabeledProps, 'children'> & DropdownDeprecatedProps;
type LabeledHorizontalSelect = Omit<LabeledProps, 'children'> &
  HorizontalSelectProps;

interface ActionPanelProps extends CosmosComponent {
  children: ReactNode;
}

export class ActionPanel extends PureComponent<ActionPanelProps, object> {
  public static Dropdown = ({ label, testId, ...rest }: LabeledDropdown) => (
    <Labeled testId={append(testId, 'label')} label={label}>
      <DropdownDeprecated testId={append(testId, 'dropdown')} {...rest} />
    </Labeled>
  );

  public static HorizontalSelect = ({
    label,
    name,
    testId,
    ...rest
  }: LabeledHorizontalSelect) => (
    <Labeled testId={append(testId, 'label')} label={label} name={name}>
      <HorizontalSelect testId={append(testId, 'select')} {...rest} />
    </Labeled>
  );

  public render() {
    const { className, children, testId } = this.props;

    return (
      <StyledWrapper className={className} data-test-id={testId}>
        {children}
      </StyledWrapper>
    );
  }
}

const StyledWrapper = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  min-height: 60px;
  margin: 10px 0;

  & > *:not(:last-child) {
    margin-right: 15px;
  }
`;
